//THIS PROGRAM IS TO DISPLAY THE REPORTS ON PE SIDE
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { map } from 'rxjs/operators';
import { APIHelpdeskService } from '../../_services/helpdesk/API-helpdesk';
import { APIEntityService } from '../../_services/entity/API-entity';


const today = new Date();
var time_today = today.getTime();
let now = new Date();
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');

@Component({
  selector: 'app-request-status',
  templateUrl: './request-status.component.html',
  styleUrls: ['./request-status.component.css']
})
export class RequestStatusComponent implements OnInit {
  maxDate: Date = new Date();

  fileDownload: any = [];
  dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['ST#', 'Ref# ID', 'Ticket Date', 'Ticket Status', 'Ticket Status Date', 'Remarks', 'Help Desk Remarks'];
  form1: any = {};
  fetchedData: any;
  data: any = {};
  noRecord: any;

  onSubmitFilter(filterForm) {


    var param
    if (filterForm.search)
      param = filterForm.search
  
    if (typeof param === 'undefined' || param == null)
      param = "";

    var filterType
    if (filterForm.searchBy)
      filterType = filterForm.searchBy;


    if (filterForm.searchBy == "" || filterForm.searchBy == null) {
      this.$modal.errorModal({
        title: 'Request Worklist',
        msg: 'Please search by valid criteria'
      });
    }
    else if ((filterType != null && filterType != "") && (param == null || param == "")) {

      this.$modal.errorModal({
        title: 'Request Worklist',
        msg: 'Please provide ' + filterType + ' value'
      });
    }

    else {
      var data = {
        "filterType": filterType,
        "param": param,
        "entityid": this.reqId
      }

      this.hlp.requestsWorklistfilter(data)
        .subscribe({
          next: value => {
            this.dataSubject.next(value);
            this.dataSource = new MatTableDataSource();

            this.dataSource = new MatTableDataSource(value);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          }
        });

    }
  }

  onChangeDataSource(value) {
    this.dataSubject.next(value);
    this.dataSource = new MatTableDataSource();

    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator;
      console.log("dataSource : ", this.dataSource);
  }

 
  public Entity_ID: any;
  applyFilter(filterValue: string) {
    console.log("in filter");
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
 
  dataSource: any;
  public reqId: any;
  public ncprFilename: any;
  public reqDate: any;
  public uploadedBy: any;
  public userName: any;
  public entityId: any;
  form: any = {};
  showDropdown: boolean = false
  showDropdown1: boolean = false
  showDropdown2: boolean = false


  startDate1: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private es: APIEntityService,
    private db: $DBManagerService,
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
    private hlp:  APIHelpdeskService,
    

  ) {


  }
 

  ngOnInit() {

    this.reqId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
    
    console.log("____this.reqId____",this.reqId)
    this.getWorklist();
    this.maxDate.setDate(new Date().getDate());

  }

  getWorklist() {

    var data ={
      entityid: this.reqId
    }
    console.log("______________data---",data)
    this.hlp.getRequestsData(data)
      .subscribe({
        next: value => {
          this.dataSubject.next(value);
          this.dataSource = new MatTableDataSource();

          this.dataSource = new MatTableDataSource(value);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });

  }
  onApplyFilter1(filterForm1) {
    console.log(filterForm1.value);
  }
  reset() {
    this.data = {}
    console.log("inside res");
    //this.afterReset();  
    this.getWorklist();
    console.log("done reset");
    this.showDropdown = false
    this.showDropdown1 = false
    this.showDropdown2 = false;
  }
 }